import { persistStore, persistReducer } from 'redux-persist';
import { configureStore, combineReducers } from '@reduxjs/toolkit';
import storageSession from 'redux-persist/lib/storage/session';
import api from '@/services/api';
import proposalSlice from './features/proposal/proposal';
import reverseMortgageSlice from './features/reverseMortgage/reverseMortgage';
import mortgageCycleSlice from './features/mortgageCycle/mortgageCycle';
import loansSlice from './features/loanOptions/loanOptions';
import proposalOfferSlice from './features/calculate/calculate';
import rateSlice from './features/rate/rate';
import userSlice from './features/user/user';
import mixesSlice from './features/mixes/mixes';

const persistConfig = {
  key: 'root',
  storage: storageSession,
};

const appReducer = combineReducers({
  loanOptions: loansSlice,
  proposal: proposalSlice,
  reverseMortgage: reverseMortgageSlice,
  mortgageCycle: mortgageCycleSlice,
  proposalOffer: proposalOfferSlice,
  [api.reducerPath]: api.reducer,
  rate: rateSlice,
  user: userSlice,
  mixes: mixesSlice,
});

const rootReducer = (state, action) => {
  if (action.type === 'RESET_ALL') {
    return appReducer(
      {
        user: state.user,
      },
      action,
    );
  }
  return appReducer(state, action);
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: {
      ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
    },
  }).concat(api.middleware), // Add RTK Query middleware here
});

export const persistor = persistStore(store);
export default store;
